/* global Cookies */

var Reverb = window.Reverb || {};
Reverb.UserActivity = (function () {
  var cookieName = 'reverb_page_views';
  var currentPageViews = null;
  var expiresInDays = 1000;

  function init() {
    currentPageViews = parseInt(Cookies.get(cookieName));
    if (!currentPageViews) { currentPageViews = 1; }

    Cookies.set(cookieName, currentPageViews + 1, { path: '/', expires: expiresInDays });
  }

  function pageViews() {
    return currentPageViews;
  }

  return {
    init: init,
    pageViews: pageViews
  };
})();


$(function () {
  Reverb.UserActivity.init();
});



// WEBPACK FOOTER //
// ./javascripts/components/legacy/user_activity.js